/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-shadow-restricted-names */

export const getTableRowsErros = (props: any) => {
  const { commonFormErrors, tableKey } = props;
  const requiredFields: any = {};
  const results = commonFormErrors?.map((item: any) => {
    if (item?.name[1] === tableKey) {
      const textRequiredFields =
        item?.name[item?.name?.length - 1] === 'files'
          ? item?.name[item?.name?.length - 2]
          : item?.name[item?.name?.length - 1];
      requiredFields[item?.name[2]] = requiredFields[item?.name[2]]
        ? [[...requiredFields[item?.name[2]], textRequiredFields]]
        : [textRequiredFields];
      return item?.name[2];
    }
  });
  // console.log('requiredFields', requiredFields);

  return { errorRowsKeys: [...new Set(results)], requiredFields };
};
